module.exports = __webpack_public_path__ + "img/googlePlayBg.6a2a5b5b.png";